<template>
    <div class="mobile-advacne-filter">
        <div v-if="isMobile" class="card-header-title advance-filter-title advance-search-title auction-search"
             @click="expandSearch">
            Search
            <div class="advance-search-icon"><i class="fas fa-search"></i></div>
        </div>
        <div class="mobile-search" v-if="isMobile && expandedSearch">

            <div class="mobile-search-options">
                <div v-if="false" class="back-close" @click="expandSearch"><i class="fa fa-angle-left"></i> Back</div>
                <button type="button" value="search" class="btn clear_btn" :class="{ 'is-loading' : isLoading }"
                        @click="clearForm">CLEAR
                </button>
                <button type="submit" name="action" value="search" class="btn search_btn"
                        :class="{ 'is-loading' : isLoading }" @click="submitForm">SEARCH
                </button>
            </div>

            <div class="search-row row">
                <div class="col-md-6">
                    <brand></brand>
                </div>
                <div class="col-md-6">
                    <model></model>
                </div>
                <div class="col-md-6">
                    <chassis></chassis>
                </div>
                <div class="col-md-6">
                    <div class="field-control">
                        <select v-model="minYear">
                            <option :value="null" disabled>YEAR FROM</option>
                            <option v-for="year in years">{{ year }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="field-control">
                        <select v-model="maxYear">
                            <option :value="null" disabled>YEAR TO</option>
                            <option v-for="year in years">{{ year }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="field-control">
                        <select v-model="transmission" multiple>
                            <option value="" disabled>TRANSMISSION</option>
                            <option v-for="trans in transmissions">{{ trans }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="field-control">
                        <select v-model="minKm">
                            <option :value="null" disabled>MIN MILEAGE</option>
                            <option v-for="km in kms" :value="km">{{ km | formatNumber }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="field-control">
                        <select v-model="maxKm">
                            <option :value="null" disabled>MAX MILEAGE</option>
                            <option v-for="km in kms" :value="km">{{ km | formatNumber }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="field-control">
                        <select v-model="minCC">
                            <option :value="null" disabled>MIN ENGINE CC</option>
                            <option v-for="cc in ccs" :value="cc">{{ cc | formatNumber }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="field-control">
                        <select v-model="maxCC">
                            <option :value="null" disabled>MAX ENGINE CC</option>
                            <option v-for="cc in ccs" :value="cc">{{ cc | formatNumber }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="field-control">
                        <multi-select v-model="lots"
                                      :close-on-select="false"
                                      :options="existingLots"
                                      :multiple="true"
                                      placeholder="Type lot number"
                                      :taggable="true"
                                      @tag="addLot"
                                      @remove="removeLot">
                        </multi-select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="field-control">
                    <div class=" small-column upcoming-past-result">
                        <div class="auction-date-drop"  @click="toggleAuctionDates">Auction Dates  <i class="fas fa-angle-down" aria-hidden="true"></i></div>
                        <div class="auction-date-dropdown" v-if="expandAuctionDate">
                            <auction-type></auction-type>
                            <days></days>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
            <div class="advance-search">
                <specific-filter></specific-filter>
            </div>
        </div>
        <div class="columns columns-top" v-if="!isMobile">
            <div class="column">
                <div class="card">
                    <header class="card-header filter-header" @click="expandCardBody">
                        <div class="card-header-title advance-filter-title advance-search-title">
                            Search
                            <div class="advance-search-icon"><i class="fas fa-search"></i></div>
                        </div>
                        <a class="card-header-icon" aria-label="more options">
                            <span class="icon" v-if="!expanded">
                               <i class="fas fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span class="icon" v-if="expanded">
                               <i class="fas fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </a>
                    </header>
                    <div class="card-content mobile" v-if="expanded">
                        <div class="content">
                            <div class="columns">

                                <div class="column is-narrow">
                                    <brand></brand>
                                </div>
                                <div class="column is-narrow">
                                    <model></model>
                                </div>
                                <div class="column is-narrow">
                                    <chassis></chassis>
                                </div>
                                <div class="column small-column advance-search-form">
                                    <year></year>
                                    <mileage></mileage>
                                    <lot-number-input></lot-number-input>
                                </div>
                                <div class="column specific-fields is-narrow" v-if="isMobile">
                                    <displacement-range-slider></displacement-range-slider>
                                    <transmissions-specification></transmissions-specification>
                                </div>

                                <div class="column small-column upcoming-past-result">
                                    <auction-type></auction-type>
                                    <days></days>
                                    <search></search>
                                </div>
                            </div>
                            <div class="columns columns-specific">
                                <div class="column column-specific">
                                    <specific-filter></specific-filter>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns advance-tags">
            <div class="column">
                <search-query></search-query>
            </div>
        </div>
        <advance-search-result v-if="!statsStatus"></advance-search-result>
        <past-auction-table v-if="statsStatus"></past-auction-table>
    </div>
</template>

<script>
    import AuctionNavigation from './../AuctionNavigation'
    import Brand from './Inputs/Brand.vue'
    import Model from './Inputs/Model.vue'
    import Chassis from './Inputs/Chassis.vue'
    import Year from './Inputs/Year.vue'
    import Mileage from './Inputs/Mileage.vue'
    import Search from './Inputs/Search.vue'
    import AuctionType from './Inputs/AuctionType.vue'
    import Days from './Inputs/Days.vue'
    import AdvanceSearchResult from './Result/AdvanceSearchResult.vue'
    import SpecificFilter from './Specific/SpecificFilter.vue'
    import PastAuctionTable from './PastAuctions/PastAuctionTable.vue'
    import SearchQuery from './Result/SearchQuery.vue'
    import LotNumberInput from './Inputs/LotNumberInput.vue'
    import DisplacementRangeSlider from './../Specification/DisplacementRangeSlider.vue'
    import TransmissionsSpecification from './../Specification/TransmissionsSpecification.vue'
    import MultiSelect from 'vue-multiselect';

    export default {
        components: {
            AuctionNavigation,
            Brand,
            Model,
            Chassis,
            Year,
            Mileage,
            Search,
            AdvanceSearchResult,
            AuctionType,
            Days,
            SpecificFilter,
            PastAuctionTable,
            SearchQuery,
            LotNumberInput,
            DisplacementRangeSlider,
            TransmissionsSpecification,
            MultiSelect
        },
        data() {
            return {
                expanded: (document.documentElement.clientWidth < 450) ? false : true,
                expandedSearch: false,
                years: [],
                transmissions: ['AT', 'MT', 'OTHER'],
                kms: [],
                ccs: [],
                existingLots: [],
                expandAuctionDate: false,
            }
        },
        methods: {
            toggleAuctionDates(){
                this.expandAuctionDate = !this.expandAuctionDate
            },
            addLot(value) {
                this.$store.dispatch('handleQueryLots', value)
            },
            removeLot(value) {
                this.$store.dispatch('removeLotFromQuery', value)
            },
            expandSearch() {
                this.expandedSearch = !this.expandedSearch
            },
            expandCardBody() {
                this.expanded = !this.expanded
            },
            resetBrandModelAndChassis() {
                this.$store.dispatch('setChassisToDefault')
                this.$store.dispatch('setBrandModelToDefault')
            },
            generateYearsArrays() {
                let minOffset = 0, maxOffset = 80; // Change to whatever you want
                let thisYear = (new Date()).getFullYear();
                let years = [];

                for (let i = minOffset; i <= maxOffset; i++) {
                    years.push(thisYear - i);
                }

                this.years = years
            },
            generateKmsArrays() {
                let minOffset = 0, maxOffset = 30;
                let thisKms = 30;
                let kms = [];

                for (let i = minOffset; i <= maxOffset; i++) {
                    let newKms = (thisKms - i) * 10000;
                    kms.push(newKms);
                }

                this.kms = kms
            },
            generateCcsArrays() {
                let minOffset = 0, maxOffset = 10;
                let thisCcs = 10;
                let ccs = [];

                for (let i = minOffset; i <= maxOffset; i++) {
                    let newCcs = (thisCcs - i) * 1000;
                    ccs.push(newCcs);
                }

                this.ccs = ccs
            },
            submitForm() {
                if (this.$store.getters.getStatsStatus) {
                    this.$store.dispatch('setSearchQueryPageNumber', 1)
                    this.$store.dispatch('setStatsQueryFieldValue', {field: 'limit_start', value: 0})
                    this.$store.dispatch('setStatsQueryFieldValue', {field: 'limit_end', value: 30})
                    this.$store.dispatch('mergeStatsQueryWithSearch', this.$store.getters.getQuery)
                    this.$store.dispatch('fetchStatsResult')
                } else {
                    this.$store.dispatch('setResultOrderColumn', 'lot_date')
                    this.$store.dispatch('setSearchQueryPageNumber', 1)
                    this.$store.dispatch('fetchResults')
                }
                if (document.documentElement.clientWidth < 450) {
                    document.getElementById('table').scrollIntoView()
                }
                this.expandedSearch = !this.expandedSearch
            },
            clearForm() {
                this.$store.dispatch('setQueryToDefault')
                this.$store.dispatch('setModelsToDefault')
            }
        },
        computed: {

            isLoading() {
                return this.$store.getters.getSearchResultsLoadingStatus
            },
            showSelectedBrandModelForMobile() {
                if (document.documentElement.clientWidth < 450) {
                    if (this.$store.getters.getAuctionSearchQuery["brand"].length > 0) {
                        return this.$store.getters.getQueryModels.length > 0
                    }
                }
                return false
            },
            getSelectedModel() {
                return this.$store.getters.getQueryModels[0]
            },
            getSelectedBrand() {
                return this.$store.getters.getAuctionSearchQuery["brand"]
            },
            statsStatus() {
                return this.$store.getters.getStatsStatus
            },
            showBrand() {
                if (document.documentElement.clientWidth > 450) {
                    return true
                } else {
                    return this.$store.getters.getAuctionSearchQuery["brand"].length === 0
                }
            },
            showModel() {
                if (document.documentElement.clientWidth > 450) {
                    return true
                } else {
                    return this.$store.getters.getAuctionSearchQuery["brand"].length > 0
                        && this.$store.getters.getQueryModels.length === 0
                }
            },
            showChassis() {
                if (document.documentElement.clientWidth > 450) {
                    return true
                } else {
                    return this.$store.getters.getQueryModels.length > 0
                }
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            },
            minYear: {
                get: function () {
                    return this.$store.getters.getQueryYearMin
                },
                set: function (value) {
                    this.$store.dispatch('addNewYearRangeMinValue', value)
                }
            },
            maxYear: {
                get: function () {
                    return this.$store.getters.getQueryYearMax
                },
                set: function (value) {
                    this.$store.dispatch('addNewYearRangeMaxValue', value)
                }
            },
            transmission: {
                get: function () {
                    return this.$store.getters.getQueryTransmission
                },
                set: function (value) {
                    this.$store.dispatch('setTransmission', value)
                }
            },
            minKm: {
                get: function () {
                    return this.$store.getters.getQueryKmMin
                },
                set: function (value) {
                    this.$store.dispatch('addNewKmRangeMinValue', value)
                }
            },
            maxKm: {
                get: function () {
                    return this.$store.getters.getQueryKmMax
                },
                set: function (value) {
                    this.$store.dispatch('addNewKmRangeMaxValue', value)
                }
            },
            minCC: {
                get: function () {
                    return this.$store.getters.getQueryCCMin
                },
                set: function (value) {
                    //value = value.length > 0 ? value : null
                    this.$store.dispatch('addNewCCRangeMinValue', value)
                }
            },
            maxCC: {
                get: function () {
                    return this.$store.getters.getQueryCCMax
                },
                set: function (value) {
                    //value = value.length > 0 ? value : null
                    this.$store.dispatch('addNewCCRangeMaxValue', value)
                }
            },
            lots: {
                get: function () {
                    return this.$store.getters.getQueryLots
                },
                set: function () {

                }
            }
        },
        mounted() {
            this.$store.dispatch('fetchBrandsFromServer');
        },
        created() {
            if (this.$store.getters.getStatsStatus) {
                this.$store.dispatch('setSearchQueryPageNumber', 1)
                this.$store.dispatch('setStatsQueryFieldValue', {field: 'limit_start', value: 0})
                this.$store.dispatch('setStatsQueryFieldValue', {field: 'limit_end', value: 30})
                this.$store.dispatch('mergeStatsQueryWithSearch', this.$store.getters.getQuery)
                this.$store.dispatch('fetchStatsResult')
            } else {
                this.$store.dispatch('setResultOrderColumn', 'lot_date')
                this.$store.dispatch('setSearchQueryPageNumber', 1)
                this.$store.dispatch('fetchResults')
            }

            this.generateYearsArrays()

            this.generateKmsArrays()

            this.generateCcsArrays()
        }
    }
</script>

<style scoped>
    .column {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 5px;
    }

    .column-specific {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .columns-top {
        padding-top: 13px;
    }

    .small-column {
        max-width: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/AdvanceSearch.vue